import { PlatformPressable } from '@react-navigation/elements'
import { cssInterop } from 'nativewind'

cssInterop(PlatformPressable, { className: 'style' })

export { PlatformPressable }
